import { createReducer } from "@reduxjs/toolkit";
import { adminRetrieveTrainingFollowUp, resetAdminRetrieveTrainingFollowUp } from "./retrieve-training-follow-up";
import type { AdminTrainingFollowUpVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";
import type { Nullable } from "@shared-kernel/core/types/nullable";

const initialState: RetrievalState<Nullable<AdminTrainingFollowUpVM>> = { fetching: "idle", data: null };

export const adminRetrieveTrainingFollowUpReducer = createReducer<RetrievalState<Nullable<AdminTrainingFollowUpVM>>>(
  initialState,
  builder => {
    builder.addCase(adminRetrieveTrainingFollowUp.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(adminRetrieveTrainingFollowUp.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(adminRetrieveTrainingFollowUp.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetAdminRetrieveTrainingFollowUp, () => initialState);
  },
);
